<template>
  <div class="home">

  </div>
</template>

<script>
// @ is an alias to /src
import Client, { shared, Modal, Redirect } from '@shoplinedev/appbridge'
import { Oauth } from '@shoplinedev/appbridge'
export default {
  name: "HomeView",
  created() {
    let handle = new URL(window.location).searchParams.get('handle')
    let appkey = new URL(window.location).searchParams.get('appkey')
    fetch('https://api.acqtechpay.com/api/ShoplineApp/settings', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        handle: handle
      })
    }) 
      .then(res => res.json())
      .then(res => {
        if (res.status === 1) {
          const app = Client.createApp({
            appKey: appkey,
            host: shared.getHost()
          })
          window.location.href = `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?appKey=${appkey}&responseType=code&scope=${res.data.scope}&redirectUri=${this.$system_url}/about`
        }
      })
  }
};
</script>
